import { MessageSquare, PencilRuler, ClipboardCheck, Rocket } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";

const STEPS = [
  {
    n: "01",
    title: "Tell Us About Your Business",
    desc: "Send us information about your business, services, branding, and what you need.",
    Icon: MessageSquare,
  },
  {
    n: "02",
    title: "We Build Your Website",
    desc: "We design and prepare a professional website for your business.",
    Icon: PencilRuler,
  },
  {
    n: "03",
    title: "Review & Approve",
    desc: "You'll receive a preview and can request reasonable adjustments before launch.",
    Icon: ClipboardCheck,
  },
  {
    n: "04",
    title: "Go Live",
    desc: "After approval, we publish your website and help connect your domain.",
    Icon: Rocket,
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      className="bg-goc-light"
      data-testid="section-how-it-works"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24">
        <SectionHeading
          eyebrow="Process"
          title="Getting Online Is Simple"
          subtitle="A clear four-step process from first message to launch."
          testId="heading-how-it-works"
        />
        <div className="relative">
          {/* Connector line (desktop only) */}
          <div
            className="hidden lg:block absolute top-8 left-[10%] right-[10%] h-px bg-goc-border"
            aria-hidden="true"
          />
          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 relative">
            {STEPS.map(({ n, title, desc, Icon }) => (
              <li
                key={n}
                className="relative bg-white border border-goc-border rounded-2xl p-6 shadow-sm"
                data-testid={`step-${n}`}
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-goc-primary text-white shadow-sm shadow-goc-primary/30">
                    <Icon className="h-6 w-6" strokeWidth={2.25} />
                  </span>
                  <span className="text-3xl font-bold text-goc-border">
                    {n}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-semibold text-goc-text">
                  {title}
                </h3>
                <p className="mt-2 text-sm text-goc-muted leading-relaxed">
                  {desc}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
